// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__34-yW","info":"PatientInfo_info__1x94y"};